import {find, includes} from "lodash/collection"
import {
  PROCESSING_STATUS_CAN_EDIT_ADVANCED,
  PROCESSING_STATUS_CAN_EDIT_BASIC,
  PROCESSING_STATUS_CAN_EDIT_PROCESSING_TYPE,
  PROCESSING_STATUS_CREATED,
  PROCESSING_STATUS_CREATING,
  PROCESSING_STATUS_READ_ONLY,
} from "../../helpers/processings/constants"
import {isEqual, isNull} from "lodash/lang"
import {findIndex, indexOf} from "lodash/array"
import {apiAuth} from "../../main"
import notify, {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"
import {
  calculateProcessingData,
  createProcessing,
  deleteProcessing,
  getProcessing,
  listProcessing,
  moveProcessing,
  updateProcessing,
} from "../../api/api-project"
import {promiseWrapper} from "../../helpers/utils"

const defaultState = () => ({
  processingList: [],

  idProcessing: null,
  processingToCreateData: null,
  processingData: null,

  isCreated: false,
  isCreating: false,
  isBasicEditable: false,
  isAdvancedEditable: false,
  isProcessingTypeEditable: true,
  isReadOnly: false,

  mustCalculateProcessingData: false,
})
const state = defaultState()

// -------------- Mutations -------------- //
const MUTATIONS_TYPES = {
  // List
  SET_PROCESSING_LIST: "SET_PROCESSING_LIST",

  // Stepper
  SET_ID_PROCESSING: "SET_PROCESSING_ID",
  SET_PROCESSING_TO_CREATE_DATA: "SET_PROCESSING_TO_CREATE_DATA",
  SET_PROCESSING_DATA: "SET_PROCESSING_DATA",

  SET_MUST_CALCULATE_PROCESSING_DATA: "SET_MUST_CALCULATE_PROCESSING_DATA",

  // CRUD
  CREATE_PROCESSING: "CREATE_PROCESSING",
  UPDATE_PROCESSING: "UPDATE_PROCESSING",
  DELETE_PROCESSING: "DELETE_PROCESSING",

  CLEAN_PROCESSING: "CLEAN_PROCESSING",
}
const mutations = {
  [MUTATIONS_TYPES.SET_ID_PROCESSING](state, idProcessing) {
    state.idProcessing = idProcessing
  },
  [MUTATIONS_TYPES.SET_PROCESSING_DATA](state, processingData) {
    state.processingData = processingData
    state.isCreated = includes(PROCESSING_STATUS_CREATED, processingData["ab_processing_status"])
    state.isCreating = includes(PROCESSING_STATUS_CREATING, processingData["ab_processing_status"])
    state.isBasicEditable = includes(PROCESSING_STATUS_CAN_EDIT_BASIC, processingData["ab_processing_status"])
    state.isAdvancedEditable = includes(PROCESSING_STATUS_CAN_EDIT_ADVANCED, processingData["ab_processing_status"])
    state.isProcessingTypeEditable = includes(PROCESSING_STATUS_CAN_EDIT_PROCESSING_TYPE, processingData["ab_processing_status"])
    state.isReadOnly = includes(PROCESSING_STATUS_READ_ONLY, processingData["ab_processing_status"])
  },
  [MUTATIONS_TYPES.SET_PROCESSING_TO_CREATE_DATA](state, processingToCreateData) {
    state.processingToCreateData = processingToCreateData
    state.processingData = processingToCreateData
    state.isCreated = false
    state.isCreating = true
    state.isBasicEditable = true
    state.isAdvancedEditable = false
    state.isProcessingTypeEditable = true
    state.isReadOnly = false
  },
  [MUTATIONS_TYPES.SET_MUST_CALCULATE_PROCESSING_DATA](state, value) {
    state.mustCalculateProcessingData = value
  },
  [MUTATIONS_TYPES.SET_PROCESSING_LIST](state, processingList) {
    state.processingList = processingList
  },
  [MUTATIONS_TYPES.CREATE_PROCESSING](state, processingData) {
    state.processingList.push(processingData)
  },
  [MUTATIONS_TYPES.UPDATE_PROCESSING](state, processingData) {
    if (!isNull(state.processingList)) {
      const idxProcessing = findIndex(state.processingList,
        value => isEqual(value["id_processing"], processingData["id_processing"]))
      state.processingList.splice(idxProcessing, 1, processingData)
    }
  },
  [MUTATIONS_TYPES.DELETE_PROCESSING](state, processingData) {
    if (!isNull(state.processingList)) {
      const processing = find(
        state.processingList,
        ["id_processing", processingData["id_processing"]],
      )
      const idxOfProcessing = indexOf(
        state.processingList,
        processing,
      )
      state.processingList.splice(idxOfProcessing, 1)
    }
  },
  [MUTATIONS_TYPES.CLEAN_PROCESSING](state) {
    Object.assign(state, defaultState())
  },
}

// -------------- Getters -------------- //
export const GET_PROCESSING_LIST = "GET_PROCESSING_LIST"
export const GET_ID_PROCESSING = "GET_ID_PROCESSING"
export const GET_PROCESSING_DATA = "GET_PROCESSING_DATA"
export const GET_PROCESSING_TO_CREATE_DATA = "GET_PROCESSING_TO_CREATE_DATA"
export const GET_PROCESSING_IS_BASIC_EDITABLE = "GET_PROCESSING_IS_BASIC_EDITABLE"
export const GET_PROCESSING_IS_ADVANCED_EDITABLE = "GET_PROCESSING_IS_ADVANCED_EDITABLE"
export const GET_PROCESSING_IS_READ_ONLY = "GET_PROCESSING_IS_READ_ONLY"
export const GET_PROCESSING_IS_CREATED = "GET_PROCESSING_IS_CREATED"
export const GET_PROCESSING_IS_CREATING = "GET_PROCESSING_IS_CREATING"
export const GET_PROCESSING_IS_PROCESSING_TYPE_EDITABLE = "GET_PROCESSING_IS_PROCESSING_TYPE_EDITABLE"
export const GET_MUST_CALCULATE_PROCESSING_DATA = "GET_MUST_CALCULATE_PROCESSING_DATA"
const getters = {
  [GET_PROCESSING_LIST](state) {
    return state.processingList
  },
  [GET_ID_PROCESSING](state) {
    return state.idProcessing
  },
  [GET_PROCESSING_DATA](state) {
    return state.processingData
  },
  [GET_PROCESSING_TO_CREATE_DATA](state) {
    return state.processingToCreateData
  },
  [GET_PROCESSING_IS_BASIC_EDITABLE](state) {
    return state.isBasicEditable
  },
  [GET_PROCESSING_IS_ADVANCED_EDITABLE](state) {
    return state.isAdvancedEditable
  },
  [GET_PROCESSING_IS_READ_ONLY](state) {
    return state.isReadOnly
  },
  [GET_PROCESSING_IS_CREATED](state) {
    return state.isCreated
  },
  [GET_PROCESSING_IS_CREATING](state) {
    return state.isCreating
  },
  [GET_PROCESSING_IS_PROCESSING_TYPE_EDITABLE](state) {
    return state.isProcessingTypeEditable
  },
  [GET_MUST_CALCULATE_PROCESSING_DATA](state) {
    return state.mustCalculateProcessingData
  },
}

// -------------- Actions -------------- //
//NEUTRAL Actions
export const SET_ID_PROCESSING = "SET_ID_PROCESSING"
export const SET_PROCESSING_TO_CREATE_DATA = "SET_PROCESSING_TO_CREATE_DATA"
export const SET_PROCESSING_LIST = "SET_PROCESSING_LIST"

export const LIST_PROCESSING = "LIST_PROCESSING"
export const SET_MUST_CALCULATE_PROCESSING_DATA = "SET_MUST_CALCULATE_PROCESSING_DATA"
export const CALCULATE_PROCESSING_DATA = "CALCULATE_PROCESSING_DATA"
export const GET_PROCESSING_DB = "GET_PROCESSING_DB"
export const CREATE_PROCESSING = "CREATE_PROCESSING"
export const UPDATE_PROCESSING = "UPDATE_PROCESSING"
export const DELETE_PROCESSING = "DELETE_PROCESSING"
export const MOVE_PROCESSING = "MOVE_PROCESSING"

export const CLEAN_PROCESSING = "CLEAN_PROCESSING"
const actions = {
  [LIST_PROCESSING]({commit}) {
    return promiseWrapper(listProcessing(apiAuth.getAuthToken()),
      res => {
        commit(MUTATIONS_TYPES.SET_PROCESSING_LIST, res.data.data)
      }, () => {}
    )
  },
  [SET_PROCESSING_LIST]({commit}, processingList) {
    commit(MUTATIONS_TYPES.SET_PROCESSING_LIST, processingList)
  },
  [CALCULATE_PROCESSING_DATA]({commit}, { idProcessing, data }) {
    return promiseWrapper(calculateProcessingData(apiAuth.getAuthToken(), idProcessing, data),
      res => {
        commit(MUTATIONS_TYPES.SET_PROCESSING_DATA, res.data.data)
        commit(MUTATIONS_TYPES.SET_MUST_CALCULATE_PROCESSING_DATA, false)
      },
      err => {
        notify(new NotificationOptions({
          message: err.response.data.message,
          type: NOTIFICATION_TYPES.ERROR,
        }))
      },
    )
  },
  [SET_MUST_CALCULATE_PROCESSING_DATA]({commit}, value) {
    commit(MUTATIONS_TYPES.SET_MUST_CALCULATE_PROCESSING_DATA, value)
  },
  [SET_ID_PROCESSING]({commit}, idProcessing) {
    commit(MUTATIONS_TYPES.SET_ID_PROCESSING, idProcessing)
  },
  [SET_PROCESSING_TO_CREATE_DATA]({commit}, processingToCreateData) {
    commit(MUTATIONS_TYPES.SET_PROCESSING_TO_CREATE_DATA, processingToCreateData)
  },
  [GET_PROCESSING_DB]({commit}, idProcessing) {
    return promiseWrapper(getProcessing(apiAuth.getAuthToken(), idProcessing),
      res => {
        commit(MUTATIONS_TYPES.SET_PROCESSING_DATA, res.data.data)
      },
      err => {
        notify(new NotificationOptions({
          message: err.response.data.message,
          type: NOTIFICATION_TYPES.ERROR,
        }))
      },
    )
  },
  [CREATE_PROCESSING]({commit}, processingData) {
    return promiseWrapper(createProcessing(apiAuth.getAuthToken(), processingData),
      (res) => {
        commit(MUTATIONS_TYPES.SET_PROCESSING_DATA, res.data.data)
        commit(MUTATIONS_TYPES.CREATE_PROCESSING, res.data.data)
        commit(MUTATIONS_TYPES.SET_MUST_CALCULATE_PROCESSING_DATA, true)
      },
      () => {
      },
    )
  },
  [UPDATE_PROCESSING]({commit}, {idProcessing, processingData}) {
    return promiseWrapper(updateProcessing(apiAuth.getAuthToken(), idProcessing, processingData),
      res => {
        commit(MUTATIONS_TYPES.SET_PROCESSING_DATA, res.data.data)
        commit(MUTATIONS_TYPES.UPDATE_PROCESSING, res.data.data)
        commit(MUTATIONS_TYPES.SET_MUST_CALCULATE_PROCESSING_DATA, true)
      },
      () => {
      },
    )
  },
  [MOVE_PROCESSING]({commit}, {idProcessing, cdProject}) {
    return promiseWrapper(moveProcessing(apiAuth.getAuthToken(), idProcessing, cdProject),
      res => {
        commit(MUTATIONS_TYPES.UPDATE_PROCESSING, res.data.data)
      },
      err => {
        notify(new NotificationOptions({
          message: err.response.data.message,
          type: NOTIFICATION_TYPES.ERROR,
        }))
      },
    )
  },
  [DELETE_PROCESSING]({commit}, idProcessing) {
    return promiseWrapper(deleteProcessing(apiAuth.getAuthToken(), idProcessing),
      res => {
        commit(MUTATIONS_TYPES.DELETE_PROCESSING, res.data.data)
      },
      () => {
      },
    )
  },
  [CLEAN_PROCESSING]({commit}) {
    commit(MUTATIONS_TYPES.CLEAN_PROCESSING)
  },
}

export default {
  mutations,
  getters,
  actions,
  state,
}
